import {useCallback,useSyncExternalStore} from 'react';
import {readStored,saveStored} from './state';

const preferenceEvent='reados:pdf-ink-preference';
export const pdfInkPreferenceKey=(userId:string)=>`reados.${userId}.pdf.ink.enabled.v1`;
export const pdfInkStyleKey=(userId:string)=>`reados.${userId}.pdf.ink.style.v1`;
export function parsePdfInkStyle(raw:string):{color:string;thickness:number}{
 let value:{color?:unknown;thickness?:unknown}={};try{value=JSON.parse(raw)||{};}catch{}
 return{color:typeof value.color==='string'&&/^#[0-9a-f]{6}$/i.test(value.color)?value.color:'#1d4ed8',thickness:typeof value.thickness==='number'&&[1,2,3,5,8].includes(value.thickness)?value.thickness:2};
}

/** All readers in this account share the writing preference; ink remains file-scoped. */
export function usePdfInkPreference(userId?:string):readonly[boolean,(enabled:boolean)=>void]{
 const subscribe=useCallback((listener:()=>void)=>{
  window.addEventListener('storage',listener);window.addEventListener(preferenceEvent,listener);
  return()=>{window.removeEventListener('storage',listener);window.removeEventListener(preferenceEvent,listener);};
 },[]);
 const snapshot=useCallback(()=>!!userId&&readStored<unknown>(pdfInkPreferenceKey(userId),false)===true,[userId]);
 const enabled=useSyncExternalStore(subscribe,snapshot,()=>false);
 const setEnabled=useCallback((value:boolean)=>{
  if(!userId)return;
  saveStored(pdfInkPreferenceKey(userId),value);window.dispatchEvent(new Event(preferenceEvent));
 },[userId]);
 return[enabled,setEnabled];
}

export function usePdfInkStyle(userId?:string){
 const subscribe=useCallback((listener:()=>void)=>{window.addEventListener('storage',listener);window.addEventListener(preferenceEvent,listener);return()=>{window.removeEventListener('storage',listener);window.removeEventListener(preferenceEvent,listener);};},[]);
 const snapshot=useCallback(()=>{try{return userId?localStorage.getItem(pdfInkStyleKey(userId))||'':'';}catch{return'';}},[userId]);
 const raw=useSyncExternalStore(subscribe,snapshot,()=>''),style=parsePdfInkStyle(raw);
 const change=useCallback((patch:Partial<typeof style>)=>{if(!userId)return;saveStored(pdfInkStyleKey(userId),{...parsePdfInkStyle(snapshot()),...patch});window.dispatchEvent(new Event(preferenceEvent));},[userId,snapshot]);
 return{...style,setColor:(color:string)=>change({color}),setThickness:(thickness:number)=>change({thickness})};
}
